<template>
  <div>
    <section class="py-32 px-6 bg-[var(--cream)]">
      <div class="max-w-6xl mx-auto fade-in-content">
        <div class="flex flex-col gap-16">
          <div class="text-center space-y-4">
            <h1 class="text-5xl md:text-6xl font-bold text-[var(--forest)] italic">
              Interventions &amp; Support
            </h1>
            <p class="text-xl text-[var(--moss)] italic max-w-2xl mx-auto">
              Comprehensive care models integrating clinical expertise with
              community connection.
            </p>
          </div>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
            <div
              class="flex flex-col items-center text-center space-y-6 group fade-in-item"
            >
              <div
                class="w-full aspect-video rounded-[30%_70%_70%_30%/30%_30%_70%_70%] overflow-hidden shadow-xl border-4 border-white lazy-image-container service-image-blob"
              >
                <div
                  class="w-full h-full bg-cover bg-center lazy-image"
                  data-src="/images/(6).jpeg"
                ></div>
              </div>
              <h4 class="text-3xl font-bold text-[var(--forest)] italic">
                Safe Space
              </h4>
              <p class="text-[var(--moss)] italic leading-relaxed">
                A nonjudgmental, inclusive environment for sharing and healing.
              </p>
              <router-link
                to="/interventions/safe-space"
                class="btn-organic bg-[var(--terracotta)] text-white px-8 py-3 font-bold flex items-center gap-2"
              >
                Learn More
                <span class="material-symbols-outlined">arrow_forward</span>
              </router-link>
            </div>
            <div
              class="flex flex-col items-center text-center space-y-6 lg:-translate-y-12 group fade-in-item"
            >
              <div
                class="w-full aspect-video rounded-[70%_30%_30%_70%/70%_70%_30%_30%] overflow-hidden shadow-xl border-4 border-white lazy-image-container service-image-blob"
              >
                <div
                  class="w-full h-full bg-cover bg-center lazy-image"
                  data-src="/images/(14).jpeg"
                ></div>
              </div>
              <h4 class="text-3xl font-bold text-[var(--forest)] italic">
                Professional Assistance
              </h4>
              <p class="text-[var(--moss)] italic leading-relaxed">
                Life coaching, counseling psychology, and trauma-informed care.
              </p>
              <router-link
                to="/interventions/professional-assistance"
                class="btn-organic bg-[var(--forest)] text-white px-8 py-3 font-bold flex items-center gap-2"
              >
                Learn More
                <span class="material-symbols-outlined">arrow_forward</span>
              </router-link>
            </div>
            <div
              class="flex flex-col items-center text-center space-y-6 group fade-in-item"
            >
              <div
                class="w-full aspect-video rounded-[50%_50%_20%_80%/80%_20%_80%_20%] overflow-hidden shadow-xl border-4 border-white lazy-image-container service-image-blob"
              >
                <div
                  class="w-full h-full bg-cover bg-center lazy-image"
                  data-src="/images/(113).jpeg"
                ></div>
              </div>
              <h4 class="text-3xl font-bold text-[var(--forest)] italic">
                Peer Support
              </h4>
              <p class="text-[var(--moss)] italic leading-relaxed">
                Peer-led group sessions and mentorship models for healing and
                empowerment.
              </p>
              <router-link
                to="/interventions/peer-support"
                class="btn-organic bg-[var(--terracotta)] text-white px-8 py-3 font-bold flex items-center gap-2"
              >
                Learn More
                <span class="material-symbols-outlined">arrow_forward</span>
              </router-link>
            </div>
            <div
              class="flex flex-col items-center text-center space-y-6 lg:translate-y-6 group fade-in-item"
            >
              <div
                class="w-full aspect-video rounded-[40%_60%_50%_50%/50%_50%_60%_40%] overflow-hidden shadow-xl border-4 border-white lazy-image-container service-image-blob"
              >
                <div
                  class="w-full h-full bg-cover bg-center lazy-image"
                  data-src="/images/(108).jpeg"
                ></div>
              </div>
              <h4 class="text-3xl font-bold text-[var(--forest)] italic">
                Personalized Wellness
              </h4>
              <p class="text-[var(--moss)] italic leading-relaxed">
                Tailored support plans using culturally relevant tools and
                approaches.
              </p>
              <router-link
                to="/interventions/personalized-wellness"
                class="btn-organic bg-[var(--forest)] text-white px-8 py-3 font-bold flex items-center gap-2"
              >
                Learn More
                <span class="material-symbols-outlined">arrow_forward</span>
              </router-link>
            </div>
            <div
              class="flex flex-col items-center text-center space-y-6 group fade-in-item"
            >
              <div
                class="w-full aspect-video rounded-[60%_40%_40%_60%/60%_60%_40%_40%] overflow-hidden shadow-xl border-4 border-white lazy-image-container service-image-blob"
              >
                <div
                  class="w-full h-full bg-cover bg-center lazy-image"
                  data-src="/images/(110).jpeg"
                ></div>
              </div>
              <h4 class="text-3xl font-bold text-[var(--forest)] italic">
                Raising Awareness
              </h4>
              <p class="text-[var(--moss)] italic leading-relaxed">
                Community education, storytelling, and advocacy for reducing
                mental health stigma.
              </p>
              <router-link
                to="/interventions/raising-awareness"
                class="btn-organic bg-[var(--terracotta)] text-white px-8 py-3 font-bold flex items-center gap-2"
              >
                Learn More
                <span class="material-symbols-outlined">arrow_forward</span>
              </router-link>
            </div>
            <div
              class="flex flex-col items-center text-center space-y-6 lg:-translate-y-6 group fade-in-item"
            >
              <div
                class="w-full aspect-video rounded-[50%_50%_30%_70%/70%_30%_70%_30%] overflow-hidden shadow-xl border-4 border-white lazy-image-container service-image-blob"
              >
                <div
                  class="w-full h-full bg-cover bg-center lazy-image"
                  data-src="/images/(13).jpeg"
                ></div>
              </div>
              <h4 class="text-3xl font-bold text-[var(--forest)] italic">
                LMHE Engagement
              </h4>
              <p class="text-[var(--moss)] italic leading-relaxed">
                Tools and training for individuals, researchers, and
                organizations looking to partner ethically with people with
                lived mental health experience.
              </p>
              <router-link
                to="/interventions/lmhe-engagement"
                class="btn-organic bg-[var(--forest)] text-white px-8 py-3 font-bold flex items-center gap-2"
              >
                Learn More
                <span class="material-symbols-outlined">arrow_forward</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted } from "vue";

export default {
  name: "ServicesPage",
  setup() {
    // Lazy load images with fade-in
    const setupLazyLoading = () => {
      const imageContainers = document.querySelectorAll(
        ".lazy-image-container",
      );
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const container = entry.target;
              const imgDiv = container.querySelector(".lazy-image");
              if (imgDiv && !imgDiv.classList.contains("loaded")) {
                const imageSrc = imgDiv.getAttribute("data-src");
                if (imageSrc) {
                  const img = new Image();
                  img.onload = () => {
                    imgDiv.style.backgroundImage = `url('${imageSrc}')`;
                    imgDiv.classList.add("loaded");
                    container.classList.add("fade-in");
                  };
                  img.src = imageSrc;
                }
              }
              observer.unobserve(container);
            }
          });
        },
        {
          rootMargin: "50px",
        },
      );

      imageContainers.forEach((container) => observer.observe(container));
    };

    // Staggered fade-in for content and items
    const setupSectionFadeIn = () => {
      // Observer for main content containers
      const contentElements = document.querySelectorAll(".fade-in-content");
      let visibleContentCount = 0;

      const contentObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (
              entry.isIntersecting &&
              !entry.target.classList.contains("fade-in-visible")
            ) {
              const delay = visibleContentCount * 150;
              setTimeout(() => {
                entry.target.classList.add("fade-in-visible");
              }, delay);
              visibleContentCount++;
              contentObserver.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: "-10% 0px -10% 0px",
          threshold: 0.1,
        },
      );

      contentElements.forEach((content) => {
        contentObserver.observe(content);
      });

      // Observer for individual items (cards, columns, etc.)
      const itemElements = document.querySelectorAll(".fade-in-item");
      let visibleItemCount = 0;

      const itemObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (
              entry.isIntersecting &&
              !entry.target.classList.contains("fade-in-visible")
            ) {
              const delay = visibleItemCount * 100; // 100ms delay between items for faster stagger
              setTimeout(() => {
                entry.target.classList.add("fade-in-visible");
              }, delay);
              visibleItemCount++;
              itemObserver.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: "-5% 0px -5% 0px", // Trigger earlier for items
          threshold: 0.1,
        },
      );

      itemElements.forEach((item) => {
        itemObserver.observe(item);
      });
    };

    onMounted(() => {
      // Setup lazy loading
      setupLazyLoading();

      // Setup section fade-in animations
      setupSectionFadeIn();
    });
  },
};
</script>

<style scoped>
/* Staggered fade-in content */
.fade-in-content {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-content.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* Staggered fade-in items */
.fade-in-item {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-item.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* Lazy loading fade-in */
.lazy-image-container {
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.lazy-image-container.fade-in {
  opacity: 1;
}

.lazy-image {
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.lazy-image.loaded {
  opacity: 1;
}

/* Service image blob hover effect */
.service-image-blob {
  transition: border-radius 0.5s ease-in-out;
}

.group:hover .service-image-blob {
  border-radius: 50% 50% 45% 55% / 60% 60% 40% 40% !important;
}
</style>
